import { api, ApiMethods, ApiRoutes } from './ApiService';
import { Type } from '../types/Type';

function parseTypeResponse(data: unknown): Type | null {
    if (!data || typeof data !== 'object') {
        return null;
    }
    const record = data as { type?: Type };
    return record.type ?? null;
}

export const AdminTypeService = {
    async getAllTypes(): Promise<Type[]> {
        const response = await api.get(ApiRoutes.TYPES);
        return response.data?.data?.types ?? [];
    },

    async createType(name: string, kKategorie: number | null, picture?: File): Promise<Type> {
        const payload: Record<string, string | number | File> = { name: name.trim() };
        if (kKategorie != null && kKategorie > 0) {
            payload.kKategorie = kKategorie;
        }
        if (picture) {
            payload.picture = picture;
        }

        const response = await api.post(ApiRoutes.TYPES, undefined, payload);
        const type = parseTypeResponse(response.data?.data);
        if (!type) {
            throw new Error('Branche konnte nicht angelegt werden');
        }
        return type;
    },

    async updateType(id: number, name: string, kKategorie: number | null): Promise<Type> {
        const payload: Record<string, string | number> = {
            name: name.trim(),
        };
        if (kKategorie != null && kKategorie > 0) {
            payload.kKategorie = kKategorie;
        }

        const response = await api.callApi(
            `${ApiRoutes.TYPES}/${id}/update`,
            ApiMethods.POST,
            payload
        );
        const type = parseTypeResponse(response.data?.data);
        if (!type) {
            throw new Error('Branche konnte nicht gespeichert werden');
        }
        return type;
    },

    async uploadPicture(id: number, picture: File): Promise<Type> {
        const response = await api.callApi(
            `${ApiRoutes.TYPES}/${id}/picture`,
            ApiMethods.POST,
            { picture }
        );
        const type = parseTypeResponse(response.data?.data);
        if (!type) {
            throw new Error('Bild konnte nicht gespeichert werden');
        }
        return type;
    },

    async deletePicture(id: number): Promise<Type> {
        const response = await api.callApi(
            `${ApiRoutes.TYPES}/${id}/picture`,
            ApiMethods.DELETE
        );
        const type = parseTypeResponse(response.data?.data);
        if (!type) {
            throw new Error('Bild konnte nicht entfernt werden');
        }
        return type;
    },

    async deleteType(id: number): Promise<void> {
        await api.delete(ApiRoutes.TYPES, id);
    },
};
